import { clearStream } from 'src/utils/media/stream';
import { detachMediaElement } from 'src/utils/media/view';

import { getImage } from './utils';

class MediaStreamPipe {
  protected inputVideoEl: HTMLVideoElement | null = null;

  /**
   * 송출용 MediaStream (미디어 스트림 객체는 유지한 채 track만 변경하여 제어)
   */
  readonly mediaStream: MediaStream = new MediaStream();

  protected outputCanvasEls: HTMLCanvasElement[] = [];

  protected drawOriginalVideo() {
    const inputVideoEl = this.inputVideoEl;
    if (!inputVideoEl || this.outputCanvasEls.length === 0) {
      return;
    }

    const sourceImage = getImage(inputVideoEl);
    if (!sourceImage) {
      return;
    }

    const { videoWidth, videoHeight } = inputVideoEl;

    // 모든 outputCanvasEls에 렌더링
    this.outputCanvasEls.forEach((outputCanvasEl) => {
      outputCanvasEl.width = videoWidth;
      outputCanvasEl.height = videoHeight;
      const context = outputCanvasEl.getContext('2d');
      if (!context) {
        return;
      }

      context.clearRect(0, 0, videoWidth, videoHeight);
      context.drawImage(sourceImage, 0, 0, videoWidth, videoHeight);
    });
  }

  public setEl(
    inputVideoEl: HTMLVideoElement,
    outputCanvasEl?: HTMLCanvasElement | HTMLCanvasElement[]
  ) {
    this.inputVideoEl = inputVideoEl;

    if (outputCanvasEl) {
      if (Array.isArray(outputCanvasEl)) {
        this.outputCanvasEls = outputCanvasEl;
      } else {
        this.outputCanvasEls = [outputCanvasEl];
      }
    } else {
      // 기본적으로 하나의 canvas 생성
      this.outputCanvasEls = [document.createElement('canvas')];
    }
  }

  public updateMediaStream() {
    // clear previous tracks
    clearStream(this.mediaStream);

    const firstCanvas = this.outputCanvasEls[0];
    if (firstCanvas) {
      /**
       * firefox에서 captureStream() 호출 시, NS_ERROR_NOT_INITIALIZED 에러 발생함
       * @see https://bugzilla.mozilla.org/show_bug.cgi?id=1572422
       */
      firstCanvas.getContext('2d');

      // 새로운 대표 canvas를 기반으로 track 대체
      this.mediaStream.addTrack(firstCanvas.captureStream().getVideoTracks()[0]);
    }
  }

  public stopRendering() {}

  public dispose() {
    if (this.inputVideoEl) {
      detachMediaElement(this.inputVideoEl);
      this.inputVideoEl = null;
    }

    clearStream(this.mediaStream);
    this.outputCanvasEls = [];
  }

  public addOutputCanvas(canvas: HTMLCanvasElement) {
    if (!this.outputCanvasEls.includes(canvas)) {
      this.outputCanvasEls.push(canvas);
      this.updateMediaStream();
    }
  }

  public removeOutputCanvas(canvas: HTMLCanvasElement) {
    const index = this.outputCanvasEls.indexOf(canvas);
    if (index > -1) {
      this.outputCanvasEls.splice(index, 1);
      this.updateMediaStream();
    }
  }

  public startRendering() {}

  public renderVideo() {}

  public render() {}

  public getInputVideoEl() {
    return this.inputVideoEl;
  }
}

export default MediaStreamPipe;
